<template>
  <div>
    <div class="community-layout">
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from '@/decorators';
@Component({
  components: {
  },
})
export default class CommunityLayout extends Vue {
}
</script>

<style lang="scss" scoped>
</style>
